import { gsap } from "gsap";

if ($('.key-visual').length > 0) {

    function intro() {
        let tl = gsap.timeline({
            repeat: 0,
            repeatDelay: 0
        });

        tl.from('.key-visual .frame:nth-child(2)', {
            y: 32,
            opacity: 0,
            duration: 1,
            ease: 'power1.inOut',
        });

        tl.from('.key-visual .frame:nth-child(1)', {
            x: -32,
            opacity: 0,
            duration: 1,
            ease: 'power1.inOut',
        }, .75);

        tl.from('.key-visual .frame:nth-child(3)', {
            x: 32,
            opacity: 0,
            duration: 1,
            ease: 'power1.inOut',
        }, .5);

        tl.from('.key-visual .orb:nth-child(1)', {
            opacity: 0,
            duration: 1,
            ease: 'power1.inOut',
        }, 1);

        tl.from('.key-visual .orb:nth-child(2)', {
            opacity: 0,
            duration: 1,
            ease: 'power1.inOut',
        }, 1.25);

        tl.from('.key-visual .orb:nth-child(3)', {
            opacity: 0,
            duration: 1,
            ease: 'power1.inOut',
        }, 1.5);

        tl.from('.key-visual .orb:nth-child(4)', {
            opacity: 0,
            duration: 1,
            ease: 'power1.inOut',
        }, 1.75);

        return tl;
    }

    function framesAfterIntro() {
        let tl = gsap.timeline({
            repeat: -1,
            repeatDelay: 0,
            yoyo: true
        });

        tl.to('.key-visual .frame:nth-child(2)', {
            y: -16,
            duration: 5,
            ease: 'power1.inOut',
        });

        tl.to('.key-visual .frame:nth-child(1)', {
            transform: 'rotate3d(0, 1, -.15, 40deg)',
            duration: 5,
            ease: 'power1.inOut',
        }, 0);

        tl.to('.key-visual .frame:nth-child(3)', {
            transform: 'rotate3d(0, 1, -.15, -40deg)',
            duration: 5,
            ease: 'power1.inOut',
        }, 0);

        return tl;
    }

    function orbsAfterIntro() {
        let tl = gsap.timeline({
            repeat: -1,
            repeatDelay: 0,
        });

        tl.to('.key-visual .orb', {
            rotate: 360,
            duration: 10,
            ease: 'none',
        }, 0);

        tl.to('.key-visual .orb__background', {
            rotate: -360,
            duration: 10,
            ease: 'none',
        }, 0);

        return tl;
    }

    let master = gsap.timeline();

    master
        .add(intro())
        .add(framesAfterIntro(), 2)
        .add(orbsAfterIntro(), 0);

}
